import React from "react";
import { RCCBadge, RCCHidden } from "react-common-components";
import { useHistory } from "react-router-dom";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { AuditSituation, AuditType, GroupersAudit } from "src/pages/Audits/Panel/interface";
import { IDashboardAuditsData } from "../interface";
import { TitleListAudits } from "../styles";

interface ILI{
    data?: IDashboardAuditsData;
}

const Li: React.FC<ILI> = ({
	data
}) => {
	const { translate } = useTranslation();

	const history = useHistory();

	if(!data)
		return <div></div>;

	return (
		<>
			<div>
				<Title color="purple" size="sm">
					<TitleListAudits>
						{data.title ? translate(data.title) : ""}
					</TitleListAudits>
				</Title>
			</div>
			<div>
				<RCCBadge 
					color="purple" 
					layout="isSquare" 
					onClick={() => history.push(`/audit/panel/?group=${GroupersAudit.TYPE}&type=${data.title === "Externa" ? AuditType.EXTERNAL :  AuditType.INTERNAL}&situation=${AuditSituation.OPENED}`)}
				>
					{data.opened}
				</RCCBadge>
				<RCCHidden mdUp>
					{translate("Abertas")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge 
					color="blue" 
					layout="isSquare" 
					onClick={() => history.push(`/audit/panel/?group=${GroupersAudit.TYPE}&type=${data.title === "Externa" ? AuditType.EXTERNAL :  AuditType.INTERNAL}&situation=${AuditSituation.IN_AUDIT}`)}
				>
					{data.inAudit}
				</RCCBadge>
				<RCCHidden mdUp>
					{translate("Em Auditoria")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge 
					color="green" 
					layout="isSquare" 
					onClick={() => history.push(`/audit/panel/?group=${GroupersAudit.TYPE}&type=${data.title === "Externa" ? AuditType.EXTERNAL :  AuditType.INTERNAL}&situation=${AuditSituation.FINISHED}`)}
				>{data.finished}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Concluídas")}
				</RCCHidden>
			</div>	
			<div>
				<RCCBadge 
					color="grey" 
					layout="isSquare" 
					onClick={() => history.push(`/audit/panel/?group=${GroupersAudit.TYPE}&type=${data.title === "Externa" ? AuditType.EXTERNAL :  AuditType.INTERNAL}`)}
				>
					{data.count}
				</RCCBadge>
				<RCCHidden mdUp>
					{translate("Total")}
				</RCCHidden>
			</div>
		</>
	);
};

export default Li;
